import * as yup from 'yup';

const MediaSchema = yup.object({
  filename: yup.string().optional(),
  public_url: yup.string().optional(),
  bucket: yup.string().optional(),
  path: yup.string().optional(),
  size: yup.number().min(0).optional(),
  mime_type: yup.string().optional(),
  uploaded_at: yup.date().optional(),
});

export const startDryingLotSchema = yup.object({
  drying_start_time: yup.date().required('Start of drying is required.'),
  drying_start_weight_kg: yup
    .number()
    .typeError('Input weight must be a number')
    .required('Input weight of coffee is required.')
    .positive('Input weight must be greater than 0')
    .test(
      'max-2-decimals',
      'Input weight can have at most 2 decimal places',
      value => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
    ),
  drying_beds: yup
    .array()
    .of(
      yup.object({
        lot_id: yup.string().optional(),
        bed_number: yup.number().required('Bed number is required'),
        lotname: yup.string().required('Lot name is required'),
        drying_start_time: yup.date().required('Drying start time is required'),
        bed_position: yup.string().required('Bed position is required'),
        lot_number: yup.number().required('Lot number is required'),
        estate_id: yup.string().required('Estate is required'),
      })
    )
    .min(1, 'Select at least one bed')
    .required('Select at least one bed'),
});

export const dryingCheckSchema = yup.object({
  time_of_check: yup.date().required('Time of check is required'),
  was_coffee_raked: yup.boolean().required('Was coffee raked is required'),
  moisture: yup
    .mixed()
    .optional()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : originalValue))
    .test('is-number', 'Input weight must be a number', value => value === null || !isNaN(value))
    .test('max-2-decimals', 'Input weight can have at most 2 decimal places', value => {
      if (value === null || value === undefined) return true;

      const str = value.toString();

      // allows: 9 | 9.8 | 9.88
      return /^\d+(\.\d{1,2})?$/.test(str);
    })
    .test('positive', 'Input weight must be greater than 0', value => value === null || Number(value) > 0),
  // moisture: yup
  //   .number()
  //   .optional()
  //   .nullable()
  //   .typeError('Input weight must be a number')
  //   .positive('Input weight must be greater than 0')
  //   .test(
  //     'max-2-decimals',
  //     'Input weight can have at most 2 decimal places',
  //     value => value === undefined || Number.isInteger(value * 100)
  //   ),
  temperature: yup
    .number()
    .optional()
    .nullable()
    .test(
      'max-2-decimals',
      'Temperature can have at most 2 decimal places',
      value => value === undefined || Number.isInteger(value * 100)
    ),
  notes: yup.string().optional(),
  media: yup.array().of(MediaSchema).optional().nullable(),
});

export const endDryingSchema = yup.object({
  drying_end_time: yup.date().required('Drying end time is required'),
  drying_end_weight_kg: yup
    .number()
    .typeError('Output weight must be a number')
    .required('Output weight is required')
    .positive('Output weight must be greater than 0')
    .test(
      'max-2-decimals',
      'Output weight can have at most 2 decimal places',
      value => value === undefined || Number.isInteger(value * 100)
    ),
});

export const addDryingBedSchema = yup.object({
  beds: yup
    .array()
    .of(
      yup.object({
        lot_id: yup.string().optional(),
        bed_number: yup.number().required('Bed number is required'),
        lotname: yup.string().required('Lot name is required'),
        drying_start_time: yup.date().required('Drying start time is required'),
        bed_position: yup.string().required('Bed position is required'),
        lot_number: yup.number().required('Lot number is required'),
        estate_id: yup.string().required('Estate is required'),
      })
    )
    .optional(),
});
